/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Online_Pending_TitleInputs */

const en_fc_online_pending_title = /** @type {(inputs: Fc_Online_Pending_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how to try FilmCraft`)
};

/**
* | output |
* | --- |
* | "Choose how to try FilmCraft" |
*
* @param {Fc_Online_Pending_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_online_pending_title = /** @type {((inputs?: Fc_Online_Pending_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Online_Pending_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_online_pending_title(inputs)
});
export { fc_online_pending_title as "fc.online.pending.title" }